import React from "react";
import { BsTwitter, BsBehance, BsGithub } from "react-icons/bs";
import { AiFillFilePdf } from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";
const SocialMedia = () => {
  return (
    <div className="app__social">
      <a
        href="https://drive.google.com/file/d/1Hk1bRqDFU-BA1UdSzTfql-4YXS1waG16/view?usp=sharing"
        target="_blank"
      >
        <div>
          <AiFillFilePdf />
        </div>
      </a>
      <a href="https://twitter.com/niskuldeep" target="_blank">
        <div>
          <BsTwitter />
        </div>
      </a>

      <a
        href="https://www.linkedin.com/in/kuldeep-singh-nishad"
        target="_blank"
      >
        <div>
          <FaLinkedinIn />
        </div>
      </a>

      <a href="https://www.behance.net/niskuldeep" target="_blank">
        <div>
          <BsBehance />
        </div>
      </a>

      <a href="https://github.com/nisKULDEEP" target="_blank">
        <div>
          <BsGithub />
        </div>
      </a>
    </div>
  );
};

export default SocialMedia;
